<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.class.classAdd') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mt-6">
                        <v-col cols="12">
                            <v-text-field
                                :label="$vuetify.lang.t('$vuetify.custom.class.className')+'*'"
                                v-model="formData.className"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :rules="[rules.required]"
                                :items="roomItems"
                                :label="$vuetify.lang.t('$vuetify.custom.class.room')"
                                hide-details
                                solo
                                :readonly="readonly"
                                v-model="formData.classRoomId"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="formData.classStart"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="formData.classStart"
                                        label="开班时间"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="formData.classStart" locale="zh-cn" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">取消</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu.save(formData.classStart)">确定</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
<!--                        <v-col cols="12">-->
<!--                            <v-text-field-->
<!--                                :rules="[rules.required]"-->
<!--                                :label="$vuetify.lang.t('$vuetify.custom.class.teacher')+'*'"-->
<!--                                v-model="formData.teacher"-->
<!--                            ></v-text-field>-->
<!--                        </v-col>-->
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}
                </v-btn>
                <v-btn color="success" dark @click="updateClass">{{ $vuetify.lang.t('$vuetify.custom.class.update') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>

    export default {
        name: 'class-update',
        model: {
            prop: 'updateClassDialog',
            event: 'parent-event'
        },
        props: {
            dialog: Boolean,
            classMsg:Object
        },
        mounted(){
            this.initSelect()
            this.updateMsg()
        },
        watch:{
            classMsg(){
                this.updateMsg()
            }
        },
        data: () => ({
            readonly:false,
            menu: false,
            formData: {
                id:'',
                classRoomId:'',
                className: '',
                classStart: new Date().toISOString().substr(0, 10),
            },
            rules: {
                required: value => !!value || '请输入'
            },
            roomItems: [
                {text: '请选择教室', value: ''},
            ],
            schoolItems: [
                {text: '请选择', value: ''},
                {text: '山东科技大学', value: '山东科技大学'},
                {text: '山东英才学院', value: '山东英才学院'},
                {text: '德州科技学院', value: '德州科技学院'},
            ],
        }),
        methods: {
            updateMsg(){
                this.formData.id = this.classMsg.id
                this.formData.classRoomId = this.classMsg.classRoomId
                this.formData.className = this.classMsg.className
                this.formData.classStart = this.classMsg.classStart
                if(this.formData.classRoomId != "" && this.formData.classRoomId != null){
                    this.readonly = true
                }else {
                    this.readonly = false
                }
            },
            initSelect(){
                this.$api.bizClassRoom.selectAllClassRoom().then((data)=>{
                    if(data.data){
                        data.data.forEach(val=>{
                            this.roomItems.push({text:val.roomName,value:val.roomId})
                        })
                    }
                })
            },
            hiddenDialog() {
                this.$emit('parent-event', false);
            },
            updateClass() {
                if (this.$refs.form.validate()) {
                    this.$api.classList.updateClass(this.formData).then(data => {
                      if (data.flag) {
                        this.$dialog.alert("修改成功");
                        this.$emit('initialize')
                        this.hiddenDialog();
                      }else{
                        this.$dialog.alert(data.msg)
                      }
                    })
                }else {
                    this.$dialog.alert("请选择教室");
                }
            }
        },
        components: {
        },
    }
</script>
